const _temp0 = require("./main.webp");
const _temp1 = require("./onepacific_2.webp");
const _temp2 = require("./onepacific_32.webp");
module.exports = {
  "main": _temp0,
  "onepacific_2": _temp1,
  "onepacific_32": _temp2
}